import React from 'react';
import Flag from 'react-flagkit';
import { useTranslation } from 'react-i18next';

import { STORAGE_KEYS } from '@/services/storageKeys';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const selectRef = React.useRef<HTMLSelectElement>(null);

  const languages = [
    { code: 'en', name: t('languages.en'), display: 'EN', country: 'GB' },
    { code: 'th', name: t('languages.th'), display: 'TH', country: 'TH' },
  ];

  const currentLang = (i18n.language || 'en').split('-')[0];
  const flagCountry =
    languages.find((l) => l.code === currentLang)?.country || 'US';

  const handleLanguageChange = (languageCode: string) => {
    console.log(`🌐 User manually selected language: ${languageCode}`);
    i18n.changeLanguage(languageCode);
    // Mark that user has made a manual language selection
    localStorage.setItem(STORAGE_KEYS.USER_SELECTED_LANGUAGE, 'true');
    // Store the selected language (i18next already does this, but being explicit)
    localStorage.setItem(STORAGE_KEYS.I18N_LANGUAGE, languageCode);
  };

  return (
    <div className="border-border-inactive relative flex items-center gap-2 rounded border p-2">
      {/* Flag for the current language */}
      <Flag country={flagCountry} />

      {/* Visible label showing current language */}
      <span className="font-regular text-primary-text select-none">
        {languages.find((l) => l.code === currentLang)?.display ||
          currentLang.toUpperCase()}
      </span>

      {/* Invisible full-overlay select capturing clicks anywhere within the container */}
      <select
        aria-label={t('languages.selectLabel', 'Select language')}
        ref={selectRef}
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="absolute inset-0 h-full w-full cursor-pointer appearance-none border-none bg-transparent opacity-0 outline-none focus:border-transparent focus:ring-0 focus:outline-none"
      >
        {languages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.display}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
